import { type UseQueryResult, useQuery } from 'react-query';
import {
  GrantAcceptanceTemplateService,
  PagedResultDto_GrantAcceptanceTemplateListDto,
} from '../../services/wealthlane-award-services';
import { type TableParams } from '../../types/common';

const useGetGrantAcceptanceTemplateList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo?: TableParams
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_GrantAcceptanceTemplateListDto | undefined,
  unknown
> => {
  const { filter, sorting, skipCount, maxResultCount } = tableInfo ?? {
    filter: '',
    sorting: '',
    skipCount: 0,
    maxResultCount: 10,
  };

  const grantAcceptanceTemplateList = useQuery(
    ['getGrantAcceptanceTemplateList', filter, sorting, skipCount, maxResultCount],
    async () => {
      return await handleRequest(
        GrantAcceptanceTemplateService.getApiAwardApiAppGrantAcceptanceTemplate(
          undefined,
          filter || undefined,
          sorting || undefined,
          skipCount,
          maxResultCount
        )
      );
    },
    { keepPreviousData: true }
  );

  return grantAcceptanceTemplateList;
};

export default useGetGrantAcceptanceTemplateList;
